/**
 * Pagination Constants
 * 페이징 관련 상수
 *
 * 프로젝트 전체에서 사용되는 페이지 크기를 중앙에서 관리합니다.
 * 하드코딩된 페이지 크기를 제거하고 일관성을 유지합니다.
 */

export const PAGINATION = {
  /**
   * 기본 페이지 크기
   * - 일반적인 목록 조회에 사용
   */
  DEFAULT_SIZE: 20,

  /**
   * 상세 페이지용 작은 크기
   * - 고객 상세 페이지의 최근 이력 (상담, 예약)
   * - 대시보드의 최근 항목
   */
  DETAIL_PAGE_SIZE: 5,

  /**
   * 소형 목록 크기
   * - 관리자 페이지의 간단한 목록
   */
  SMALL_SIZE: 10,

  /**
   * 중형 목록 크기
   * - 클라이언트 사이드 페이징
   * - 일반적인 목록 페이지
   */
  MEDIUM_SIZE: 20,

  /**
   * 대형 목록 크기
   * - 사용자 관리 페이지
   * - 많은 데이터를 한번에 조회해야 하는 경우
   */
  LARGE_SIZE: 100,

  /**
   * 최대 크기 (사용 자제 권장)
   * - 전체 데이터 조회가 필요한 특수한 경우만 사용
   * - 성능 문제 발생 가능성 주의
   */
  MAX_SIZE: 1000,

  /**
   * 관리자 페이지 기본 크기
   */
  ADMIN_SIZE: 10,

  /**
   * 검색 결과 기본 크기
   */
  SEARCH_SIZE: 20,
} as const;

/**
 * 페이지 크기 타입
 */
export type PaginationSize = typeof PAGINATION[keyof typeof PAGINATION];
